import { createElement } from 'react';
import { registerStorageToolbarExtension } from '../toolbar/toolbarExtensions';
import { ClearQueueMenuItem, QueueMessageToolbar } from './QueueMessageToolbar';
import { registerS5QueueDialogOpener, registerS5StorageTreeExtension } from './queueMenuItems';
import { openAddMessageDialog, openClearQueueConfirm, openCreateQueueDialog, openDeleteQueueConfirm } from './queueDialogs';
import { AddQueueMessageDialog } from './dialogs/AddQueueMessageDialog';
import { CreateQueueDialog } from './dialogs/CreateQueueDialog';
import { ReceiveMessagesDialog } from './dialogs/ReceiveMessagesDialog';
import { UpdateQueueMessageDialog } from './dialogs/UpdateQueueMessageDialog';

registerStorageToolbarExtension({
  id: 's5-queue', placement: 'primary', order: 410,
  isVisible: (context) => context.mode === 'messages',
  render: (context) => createElement(QueueMessageToolbar, { key: 's5-queue', context }),
});
// UI/UX fix round A (U21): Clear queue sits in More, destructive and last (the toolbar placement rule).
registerStorageToolbarExtension({
  id: 's5-clear-queue', placement: 'more', order: 420, destructive: true,
  isVisible: (context) => context.mode === 'messages',
  render: (context) => createElement(ClearQueueMenuItem, { key: 's5-clear-queue', context }),
});
// The Queues folder's menu items and `Create queue…` row come through S2's tree-extension registry;
// `azure-storage:mutated` refresh is S2's generic `useStorageMutationSync` (service folder + query prefix).
registerS5StorageTreeExtension();

registerS5QueueDialogOpener((request) => {
  const args = { connectionId: request.connectionId, queue: request.queue, source: request.source };
  if (request.kind === 'create-queue') openCreateQueueDialog(args);
  else if (request.kind === 'add-message') openAddMessageDialog(args);
  else if (request.kind === 'clear-queue' && request.queue) openClearQueueConfirm({ ...args, queue: request.queue });
  else if (request.kind === 'delete-queue' && request.queue) openDeleteQueueConfirm({ ...args, queue: request.queue });
});

export { QueueMessageHost } from './QueueMessageHost';
export function QueueDialogsHost() {
  return createElement('div', null,
    createElement(AddQueueMessageDialog),
    createElement(ReceiveMessagesDialog),
    createElement(UpdateQueueMessageDialog),
    createElement(CreateQueueDialog),
  );
}
